<template>
  <div class="nested-view">
    <template
      v-if="showShareHistory"
    >
      <div class="section-title">{{ $t('coupons.shareHistory') }}</div>
      <section class="section section--history">
        <div class="history">
          <div
            class="history-item"
            v-for="history in couponShareHistory.slice(0, historyLength)"
            :key="history.id"
          >
            <div
              class="history-row"
            >
              <div class="content">{{ history.content }}</div>
              <div class="time">
                {{ history.send_time | moment("calendar") }}
              </div>
            </div>
          </div>
          <a
            class="more"
            v-if="historyLength < couponShareHistory.length"
            v-on:click="loadMoreHistory"
          >
            {{ $t("common.more") }}
          </a>
        </div>
      </section>
    </template>
    <div class="section-title"
      v-if="couponShareHistory.length > 0 && showShareHistory === true"
    >{{ $t("coupons.coupons") }}</div>
    <section
      class="section tool-container"
      :class="couponShareHistory.length > 0 && showShareHistory === false ? 'justify-content-between': 'justify-content-end'">
      <div
        v-if="couponShareHistory.length > 0 && showShareHistory === false"
        class="tool-btn"
        v-on:click="showShareHistory = true"
      >
        <span>{{ $t('coupons.shareHistory') }}</span>
      </div>
      <div class="d-flex justify-content-between align-center">
        <div
          class="tool-dropdown mr-2"
          v-on:click="subBrandFilter(brand.subBrand)"
          v-if="brand.subBrand"
        >
          <span v-if="subBrand.label">{{ subBrand.label }}</span>
          <span v-else>{{ $t("common.allSubBrand") }}</span>
          <i class="material-icons">expand_more</i>
        </div>
        <div
          class="tool-dropdown ml-2"
          v-on:click="pickTimeOrder()"
        >
          <span>{{ timeOrder.label }}</span>
          <i class="material-icons">expand_more</i>
        </div>
      </div>
    </section>
    <section class="section" v-if="filteredCoupons.length === 0">
      <div class="empty">
        <i class="material-icons">local_activity</i>
        {{ $t('coupons.empty') }}
      </div>
    </section>
    <section class="section" v-else>
      <div class="coupons">
        <router-link
          v-for="coupon in filteredCoupons"
          class="item"
          tag="div"
          :to="{ name: 'Coupon', params: { token: coupon.serial }}"
          :class="{
            expired: coupon.expired === '1',
            used: coupon.used === '1',
          }"
          :key="coupon.serial">
          <div class="fig">
            <img v-lazy="coupon.image">
          </div>
          <div class="meta">
            <div class="name">
              {{ coupon.title }}
            </div>
            <div class="time">
              <i class="material-icons" v-if="coupon.used !== '1'">query_builder</i>
              <i class="material-icons" v-else>check</i>
              {{ date(coupon.end_time, coupon.used === '1') }}
            </div>
          </div>
        </router-link>
      </div>
    </section>

    <powered-by></powered-by>
    <picker
      :visable="picker"
      :type="pickerType"
      :options="pickerOptions"
      v-on:pickOption="pickOption"
      v-on:reset="resetOption"
      v-on:togglePicker="picker = !picker"
    ></picker>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import Moment from 'moment';

import PoweredBy from '@/components/PoweredBy.vue';
import Picker from '@/components/Picker.vue';

export default {
  name: 'Coupons',
  data() {
    return {
      subBrand: {
        label: null,
        value: null,
      },
      picker: false,
      pickerType: null,
      pickerOptions: [],
      historyLength: 5,
      showShareHistory: false,
      timeOrder: {
        label: this.$i18n.t('coupons.expiryClosest'),
        value: 'end_time',
        ascending: true,
      },
    };
  },
  computed: {
    ...mapState(['brand', 'coupons', 'couponShareHistory']),
    filteredCoupons() {
      return this.getFilteredCoupons();
    },
  },
  methods: {
    getFilteredCoupons() {
      let allCoupons = this.coupons.slice();
      if (this.subBrand.label) {
        allCoupons = allCoupons.filter((element) => {
          if (element.available_store === null) {
            return element;
          }
          const availableStores = element.available_store.split(',').map(Number);
          const intersection = availableStores.filter(store => this.subBrand.value.includes(store));
          if (intersection.length === 0) {
            return false;
          }
          return element;
        });
      }
      return this.sortCoupons(allCoupons);
    },
    date(value, used) {
      if (!value) return '';

      const date = Moment(value);
      const now = Moment();

      if (used) {
        return this.$i18n.t('coupons.used');
      }

      if (date.isSameOrBefore(now)) {
        return this.$i18n.t('coupons.expireOn', { date: date.calendar() });
      }

      return this.$i18n.t('coupons.expired', { date: date.calendar() });
    },
    pickOption(option) {
      if (this.pickerType === 'subBrand') {
        this.subBrand = option;
      }
      if (this.pickerType === 'sortCoupons') {
        this.timeOrder = option;
      }
      this.picker = false;
      this.pickerType = null;
    },
    resetOption() {
      if (this.pickerType === 'subBrand') {
        this.subBrand = {
          label: null,
          value: null,
        };
      }
      this.picker = false;
      this.pickerType = null;
    },
    subBrandFilter(subBrand) {
      if (!subBrand) {
        return;
      }

      const options = [{
        label: this.$i18n.t('common.allSubBrand'),
        value: null,
        reset: true,
      }];

      subBrand.forEach((element) => {
        options.push({
          label: element.name,
          // eslint-disable-next-line no-underscore-dangle
          value: element._stores,
        });
      });

      this.pickerType = 'subBrand';
      this.pickerOptions = options;
      this.picker = true;
    },
    pickTimeOrder() {
      this.pickerType = 'sortCoupons';
      this.pickerOptions = [
        {
          label: this.$i18n.t('coupons.expiryClosest'),
          value: 'end_time',
          ascending: true,
        },
        {
          label: this.$i18n.t('coupons.expiryLatest'),
          value: 'end_time',
          ascending: false,
        },
        {
          label: this.$i18n.t('coupons.receiveClosest'),
          value: 'create_time',
          ascending: false,
        },
        {
          label: this.$i18n.t('coupons.receiveLatest'),
          value: 'create_time',
          ascending: true,
        },
      ];
      this.picker = true;
    },
    sortCoupons(coupons) {
      return coupons.sort((a, b) => {
        // 判斷 expired 和 used 的條件，將符合條件的放在前面
        const aFront = (a.expired !== '1' && a.used !== '1');
        const bFront = (b.expired !== '1' && b.used !== '1');

        if (aFront && !bFront) {
          return -1;
        } else if (!aFront && bFront) {
          return 1;
        }

        const timeA = Moment(this.timeOrder.value === 'create_time' ? a.create_time : a.end_time);
        const timeB = Moment(this.timeOrder.value === 'create_time' ? b.create_time : b.end_time);

        return this.timeOrder.ascending ? timeA - timeB : timeB - timeA;
      });
    },
    loadMoreHistory() {
      this.historyLength += 5;
    },
  },
  components: {
    Picker,
    PoweredBy,
  },
};
</script>

<style lang="sass" scoped>
.section-title
  margin: 24px 24px 8px

  color: #686868
  font-size: 0.875rem
  font-weight: bold
  letter-spacing: 2px
  text-transform: uppercase

  & + .section
    margin-top: 0

  &-container
    display: flex
    align-items: center
    margin: 24px 24px 8px

    & + .section
      margin-top: 0

    .section-title
      flex-grow: 1
      margin: 0

.tool-container
  margin: 24px 16px 0
  display: flex
  justify-content: space-between
  align-items: center

  text-align: center

  &:empty
    margin: 0

.tool-btn,
.tool-dropdown
  display: inline-block
  padding: 4px 8px

  border-radius: 10px

  background-color: #F5F5F5

  font-size: 0.875rem
  font-weight: bold
  color: #8E8E8E

  cursor: pointer

  span
    vertical-align: middle

  .material-icons
    margin-left: 8px

    font-size: 0.75rem
    vertical-align: middle

.empty
  padding: 15% 0

  text-align: center
  font-weight: bold
  color: #CFD8DC

  .material-icons
    display: block
    margin-bottom: 12px

    font-size: 5.5rem

.coupons
  padding: 24px 16px

.item
  position: relative

  &:not(:last-child)
    margin-bottom: 20px

  &.expired,
  &.used,
    .fig
      img
        opacity: .5

        &[lazy=loading]
          height: 0

      &::before
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        z-index: 3

        background-size: 50%
        background-repeat: no-repeat
        background-position: center

        content: ''

      &::after
        display: none

  &.expired
    .fig
      &::before
        background-image: url(/assets/img/vip/coupon-expired-en.png)
      html[lang='zh-Hant'] &::before
        background-image: url('/assets/img/vip/coupon-expired.png');

  &.used
    .fig
      &::before
        background-image: url(/assets/img/vip/coupon-used-en.png)
      html[lang='zh-Hant'] &::before
        background-image: url('/assets/img/vip/coupon-used.png');

.fig
  position: relative

  &::after
    position: absolute
    top: 8px
    right: 8px
    bottom: 8px
    left: 8px
    z-index: 1

    box-shadow: 0 2px 15px 3px rgba(0, 0, 0, .5)

    background-color: transparent

    content: ''

  img
    width: 100%
    height: auto
    position: relative
    z-index: 2

.meta
  text-align: center

.name
  margin-top: 12px

  font-size: 1rem
  font-weight: bold

.time
  font-size: 0.875rem

  color: #999

  .material-icons
    font-size: 1.125em
    vertical-align: middle

.popview
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 2000
  overflow: auto

  background-color: rgba(255, 255, 255, .75)

.section--history
  text-align: center

.history
  .history-item
    position: relative
    padding: 16px

    text-align: left

    &:not(:last-child)
      &::after
        position: absolute
        top: auto
        right: 24px
        bottom: 0
        left: 24px
        height: 1px

        background-color: #E6E6E6

        content: ''

  .more
    margin: 8px auto 0
    padding: 8px 16px
    display: inline-block

    border-radius: 10px

    background: #f5f5f5

    text-align: center
    font-size: 0.75rem
    font-weight: bold
    color: #8E8E8E

    cursor: pointer

  .content
    font-size: 0.875rem

  .time
    margin-top: 6px

  .time
    font-size: 0.75rem
    color: #8E8E8E
</style>
